import styled from 'styled-components';
import { supportReadingStyles } from '../../pages/support/SupportStyles';
export const PrivacyNoticeWrapper = styled.div`${supportReadingStyles}`;
